import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiButton, EuiSpacer, EuiFormFieldset} from '@elastic/eui';
import {ComboFuncionesContainer as ComboFunciones} from '../../../components/Combos/Funciones/container';
import {ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
import ListadoFuncionesSubFunciones from '../../../components/Listas/FuncionesSubFunciones';


export const SelectorFuncionSubFuncion = (props)=>{

  let {onAgregateFuncionSubfuncion, funcionesSubFunciones, onRemoveFuncionSubFuncion} = props;

  let [funcion, setFuncion] = useState(undefined);
  let [subFuncion, setSubFuncion] = useState(undefined);

  const onAgregate = () =>{
    let data = [{idFuncion:funcion[0].value,funcion:funcion[0].label, idSubFuncion:subFuncion[0].value, subFuncion: subFuncion[0].label}]
    onAgregateFuncionSubfuncion && onAgregateFuncionSubfuncion(data);
    setFuncion(undefined);
    setSubFuncion(undefined);
  }

  const isInvalidFuncion = useMemo(() => funcion===undefined || funcion.length===0,[funcion])
  const isInvalidSubFuncion = useMemo(() => subFuncion===undefined || subFuncion.length===0,[subFuncion])

  return (
    <EuiFormFieldset legend={{children:"Funciones/SubFunciones"}} className="funcionesSubfuncionesPorcFieldset">
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Función">
          <ComboFunciones all selectedOptions={funcion} onChange={value => setFuncion(value)}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="SubFunción">
          <ComboSubFunciones dependency idFuncion={!isInvalidFuncion ? funcion[0].value : undefined} isDisabled={!isInvalidFuncion ? false : true} 
          selectedOptions={subFuncion} onChange={value => setSubFuncion(value)} />
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiFormRow className="btnAddFuncionSubFuncion">
          <EuiButton fill onClick={onAgregate} disabled={(isInvalidFuncion || isInvalidSubFuncion)}>
            Agregar
          </EuiButton>
      </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiSpacer size="s" />
    <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <ListadoFuncionesSubFunciones
            className="listadoFuncionesSubFunciones"
            fullWidth
            options={funcionesSubFunciones}
            onRemove={onRemoveFuncionSubFuncion}
          />
        </EuiFormRow>
    </EuiFlexItem>
  </EuiFormFieldset>
  )
}
